
    import { Options, Vue } from 'vue-class-component';
    import $ from 'jquery'; 
    import Shareholderbasic from '@/components/Shareholderbasic.vue';    
    import Common from '@/services/common.js'; 
    import moment from 'moment';
    
    import Toast from '@/components/Toast.vue'; 
    import Axios from "axios";   
    import { Form, Field,ErrorMessage } from 'vee-validate';

    import bootstrap from 'bootstrap'; 
    import Select2 from 'vue3-select2-component'; 
    import { useToast } from "vue-toastification";
    import _debounce from 'lodash.debounce';
    
    import Banks from '@/components/shareholderonboard/Banks.vue';     
    import NDirectors from '@/components/shareholderonboard/NDirectors.vue';    
    import Shareholders from '@/components/shareholderonboard/Shareholders.vue';    
    import Owners from '@/components/onboard/Owners.vue';    


 
    @Options({
        components: {
            'toasti':Toast, 
            'select2':Select2,  

            Shareholderbasic,
            Banks,
            NDirectors,
            Shareholders,
            Owners,

            Form,
            Field,
            ErrorMessage
        },
    })
    export default class ShareholderDomesticCorporate extends Vue { 
        amad:any    =   false;
        token :any  =   false;

        STORAGE_KEY = "caprock-local";   
        user_name = ''; 
        shareholder_info = {}; 
        user_info = {}; 
        form = {}; 
        active_tab = 'company';
        md_owner_active = 0;
         
        no_of_directors :any= 1;
        no_of_shareholders :any= 1;

        docs :any =  [];
        local_storage:any;
        dashboard = {
            currencies:[]
        }; 
         

        load_on:any=0;

        advisor_exist :any= 0;

        request_verified:any    =   0;
        shareholders   :any        =   [];
        directors   :any        =   [];
        owners      :any        =   [];
        bank_accounts      :any        =   [];
        fresh_step      :any    =   0;
        completed_steps :any    =   [];
        users           :any    =   [];
         
        currencies      :any    =   [];
        current_step    :any    =   1;  
        cash_accounts   :any    =   []; 
        next_step:any           =   0;
        records         :any    =   {};
        reg_details     :any    =   {}; 
        countries       :any    =   []; 
        states          :any    =   [];
        final_step      :any    =   7;

        value:any       =   45;
        max:any         =   100;

        svg_image:any='<svg fill="#000000" xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 100 100" width="50px" height="50px">    <path d="M 34.179688 10.164062 C 32.103687 10.164062 30.615234 11.426266 30.615234 13.697266 L 30.648438 25.806641 C 30.648438 28.846641 32.770234 30.712891 35.615234 30.712891 C 38.460234 30.712891 40.615234 29.002891 40.615234 25.962891 L 40.615234 14.306641 L 39.613281 14.306641 L 39.523438 25.869141 C 39.523438 28.079141 37.599438 29.808594 35.648438 29.808594 C 33.697437 29.808594 31.615234 28.049844 31.615234 25.839844 L 31.644531 13.611328 C 31.644531 12.304328 33.077484 11.126953 34.271484 11.126953 C 35.465484 11.126953 36.615234 12.275031 36.615234 13.582031 L 36.615234 24.056641 C 36.615234 24.056641 36.139813 25.056641 35.632812 25.056641 C 35.125812 25.056641 34.486234 24.700391 34.615234 24.150391 L 34.615234 14.308594 L 33.615234 14.308594 L 33.582031 23.964844 C 33.582031 25.344844 34.32225 25.964844 35.65625 25.964844 C 36.99025 25.964844 37.615234 25.249141 37.615234 23.869141 L 37.615234 13.664062 C 37.615234 11.393062 36.255687 10.164062 34.179688 10.164062 z M 41.613281 11.306641 C 41.061281 11.306641 40.613281 11.754641 40.613281 12.306641 C 40.613281 12.858641 41.061281 13.306641 41.613281 13.306641 L 59.613281 13.306641 L 59.613281 23.792969 C 59.613281 29.039969 63.881906 33.306641 69.128906 33.306641 L 79.613281 33.306641 L 79.613281 82.574219 C 79.613281 86.837219 76.146812 90.306641 71.882812 90.306641 L 28.347656 90.306641 C 24.084656 90.306641 20.615234 86.838219 20.615234 82.574219 L 20.615234 21.039062 C 20.615234 16.776063 24.083656 13.308594 28.347656 13.308594 L 29.615234 13.308594 C 30.167234 13.308594 30.615234 12.860594 30.615234 12.308594 C 30.615234 11.756594 30.167234 11.308594 29.615234 11.308594 L 28.347656 11.308594 C 22.981656 11.308594 18.615234 15.672062 18.615234 21.039062 L 18.615234 82.574219 C 18.615234 87.940219 22.980656 92.306641 28.347656 92.306641 L 71.882812 92.306641 C 77.248812 92.306641 81.613281 87.940219 81.613281 82.574219 L 81.613281 32.554688 C 81.613281 32.289688 81.508313 32.035656 81.320312 31.847656 L 61.072266 11.599609 C 60.885266 11.411609 60.630234 11.306641 60.365234 11.306641 L 41.613281 11.306641 z M 60.613281 13.966797 L 78.951172 32.306641 L 69.128906 32.306641 C 64.433906 32.306641 60.613281 28.487969 60.613281 23.792969 L 60.613281 13.966797 z M 28.371094 19.505859 C 28.245219 19.481734 28.110094 19.505984 27.996094 19.583984 C 25.878094 21.023984 24.613281 23.406078 24.613281 25.955078 L 24.613281 78.617188 C 24.613281 82.856187 28.048484 86.306641 32.271484 86.306641 L 67.955078 86.306641 C 72.178078 86.306641 75.613234 82.856188 75.615234 78.617188 L 75.615234 60.806641 C 75.615234 60.530641 75.391234 60.306641 75.115234 60.306641 C 74.839234 60.306641 74.615234 60.530641 74.615234 60.806641 L 74.615234 78.617188 C 74.615234 82.305187 71.628031 85.306641 67.957031 85.306641 L 32.273438 85.306641 C 28.602438 85.306641 25.615234 82.305188 25.615234 78.617188 L 25.615234 25.955078 C 25.615234 23.737078 26.714594 21.664156 28.558594 20.410156 C 28.786594 20.255156 28.846406 19.945797 28.691406 19.716797 C 28.613906 19.603297 28.496969 19.529984 28.371094 19.505859 z M 75.113281 47.306641 C 74.837281 47.306641 74.613281 47.530641 74.613281 47.806641 L 74.613281 50.806641 C 74.613281 51.082641 74.837281 51.306641 75.113281 51.306641 C 75.390281 51.306641 75.613281 51.082641 75.613281 50.806641 L 75.613281 47.806641 C 75.613281 47.530641 75.389281 47.306641 75.113281 47.306641 z M 30.113281 51.306641 C 29.837281 51.306641 29.613281 51.530641 29.613281 51.806641 C 29.613281 52.082641 29.837281 52.306641 30.113281 52.306641 L 53.113281 52.306641 C 53.390281 52.306641 53.613281 52.082641 53.613281 51.806641 C 53.613281 51.530641 53.389281 51.306641 53.113281 51.306641 L 30.113281 51.306641 z M 75.113281 52.306641 C 74.837281 52.306641 74.613281 52.530641 74.613281 52.806641 L 74.613281 58.806641 C 74.613281 59.082641 74.837281 59.306641 75.113281 59.306641 C 75.390281 59.306641 75.613281 59.082641 75.613281 58.806641 L 75.613281 52.806641 C 75.613281 52.530641 75.389281 52.306641 75.113281 52.306641 z M 30.113281 58.306641 C 29.837281 58.306641 29.613281 58.530641 29.613281 58.806641 C 29.613281 59.082641 29.837281 59.306641 30.113281 59.306641 L 44.113281 59.306641 C 44.390281 59.306641 44.613281 59.082641 44.613281 58.806641 C 44.613281 58.530641 44.389281 58.306641 44.113281 58.306641 L 30.113281 58.306641 z M 46.113281 58.306641 C 45.837281 58.306641 45.613281 58.530641 45.613281 58.806641 C 45.613281 59.082641 45.837281 59.306641 46.113281 59.306641 L 70.113281 59.306641 C 70.390281 59.306641 70.613281 59.082641 70.613281 58.806641 C 70.613281 58.530641 70.389281 58.306641 70.113281 58.306641 L 46.113281 58.306641 z M 30.113281 65.306641 C 29.837281 65.306641 29.613281 65.530641 29.613281 65.806641 C 29.613281 66.082641 29.837281 66.306641 30.113281 66.306641 L 48.113281 66.306641 C 48.390281 66.306641 48.613281 66.082641 48.613281 65.806641 C 48.613281 65.530641 48.389281 65.306641 48.113281 65.306641 L 30.113281 65.306641 z M 50.113281 65.306641 C 49.837281 65.306641 49.613281 65.530641 49.613281 65.806641 C 49.613281 66.082641 49.837281 66.306641 50.113281 66.306641 L 61.113281 66.306641 C 61.390281 66.306641 61.613281 66.082641 61.613281 65.806641 C 61.613281 65.530641 61.389281 65.306641 61.113281 65.306641 L 50.113281 65.306641 z M 63.113281 65.306641 C 62.837281 65.306641 62.613281 65.530641 62.613281 65.806641 C 62.613281 66.082641 62.837281 66.306641 63.113281 66.306641 L 71.113281 66.306641 C 71.390281 66.306641 71.613281 66.082641 71.613281 65.806641 C 71.613281 65.530641 71.389281 65.306641 71.113281 65.306641 L 63.113281 65.306641 z M 30.113281 72.306641 C 29.837281 72.306641 29.613281 72.530641 29.613281 72.806641 C 29.613281 73.082641 29.837281 73.306641 30.113281 73.306641 L 54.113281 73.306641 C 54.390281 73.306641 54.613281 73.082641 54.613281 72.806641 C 54.613281 72.530641 54.389281 72.306641 54.113281 72.306641 L 30.113281 72.306641 z M 57.113281 72.306641 C 56.837281 72.306641 56.613281 72.530641 56.613281 72.806641 C 56.613281 73.082641 56.837281 73.306641 57.113281 73.306641 L 70.113281 73.306641 C 70.390281 73.306641 70.613281 73.082641 70.613281 72.806641 C 70.613281 72.530641 70.389281 72.306641 70.113281 72.306641 L 57.113281 72.306641 z"/></svg>'

        /*STEP 1*/
            s1_image_url :any   =   null; 
            s1_doc_url   :any   =   null;
            s1_not_image :any   =   null;
            s1_doc_path  :any   =   null;
            file_s1_name:any    =   null;
            trans_proof:any     =   null

        /*STEP 2*/
            s2_image_url :any   =   null; 
            s2_doc_url   :any   =   null;
            s2_not_image :any   =   null;
            s2_doc_path  :any   =   null;
            file_s2_name:any    =   null;
            poa_copy:any      =   null

            toast:any = useToast();

            
            search_timeout :any= null

        /*Place*/
            timer :any          = undefined;
            place_suggestion = false;
            place_list:any[]= []; 



        upload_docs :any =  [
            {
                'name'              :   'Search of the relevant Australian Stock Exchange', 
                'input_name'        :   'aus_stock_doc'
            },
            {
                'name'              :   'Organisational Chart – showing ownership by shareholding', 
                'input_name'        :   'org_chart_share'
            },
            {
                'name'              :   'ASIC Extract', 
                'input_name'        :   'asic_extract'
            },
            {
                'name'              :   'Articles of Association', 
                'input_name'        :   'association_article'
            }  
        ];
        
         
        beforeCreate(){
            this.load_on=1;
        }  
        created() {        
            document.title = "Shareholder Australian Domestic Application  || Caprock Merchant Platform";
            localStorage.setItem(
                'active_page', 'account_form'
            );  
        }
        logout(){
            localStorage.clear(); 
            this.token='';   
            this.amad='';   
            alert('Invalid URL please contact caprock team');
            location.href='https://caprock.com.au'; 
        } 
        async mounted(){
            this.user_name=''; 
            this.country_list();
            this.state_list(14);
 
            if (typeof this.$route.query.token!='undefined' && this.$route.query.token!='' && this.$route.query.token!=null && typeof this.$route.query.amad!='undefined' && this.$route.query.amad!='' && this.$route.query.amad!=null) {
                this.amad   = this.$route.query.amad;
                this.token  = this.$route.query.token; 
                this.get_shareholder_info(this.token,this.amad); 
            } else{ 
                this.logout();
            } 
            await this.get_active_step(1);     
            setTimeout(() => this.load_on=0, 500); 
        }



        /*Google Place API*/
            textSearch(e:any,id){
                clearTimeout(this.timer) 
                this.timer = setTimeout(() => {
                    Common.get_place_search(e.target.value)
                    .then(response => {   
                    if(response.status==200 && (response.data.data.results).length>0){
                        var places = response.data.data.results;   
                        $('.suggestDiv'+id).removeClass('d-none');
                        this.place_list = [];
                        this.place_suggestion=true;
                        var list_ar:any[] = []
                        for (var i = 0; i < places.length; i++) {  
                            if(i<5){
                                var suggest     = places[i]; 
                                var input_address =  suggest.name+" "+ suggest.formatted_address;
                                if(suggest.formatted_address.includes(suggest.name)){
                                    input_address = suggest.formatted_address;
                                } 
                                this.place_list.push({
                                    id      :   i+1,
                                    title   :   suggest.name,
                                    details :   suggest.formatted_address,
                                    address :   input_address,
                                    lat     :   suggest.geometry.location.lat,
                                    long    :   suggest.geometry.location.lng  
                                });  
                            }
                        } 
                        $('.addr_section'+id).addClass('m-0');
                        $('.place_suggest'+id).removeClass('d-none'); 
                    } 

                    }).catch(e => {
                      console.log(e)
                    });
                }, 500)
            }
            set_address(id,address_name,DI){
                $('#addr_'+id).removeClass('d-none');    
                var add = $('#addr_'+id).text();  
                this.form[address_name]=add;    
                $('#addr_'+id).addClass('d-none');    
                $('.place_suggest'+DI).addClass('d-none');    
                $('.addr_section'+DI).removeClass('m-0');  
            }

        data() { 
            return { 
                token               :   this.token,
                amad                :   this.amad,
                load_on             :   this.load_on, 

                directors           :   this.directors, 
                shareholders        :   this.shareholders, 
                owners              :   this.owners, 
                bank_accounts       :   this.bank_accounts, 
                 
                user_info           :   this.user_info,
                shareholder_info    :   this.shareholder_info,     
                users               :   this.users, 

                countries           :   this.countries,
                states              :   this.states,
                upload_docs         :   this.upload_docs,


                myValue : '',
                myOptions: [
                    {id:'1',text:'James'}
                ],
                value: 45,
                max: 100 
            }
        }
        
        set_final_step(event){
            var t = event.target.value;
            if(typeof t!='undefined' && t=='existing'){
                this.final_step=7;
            }else{
                this.final_step=7;
            }
        }

        randomValue() {
            this.value = Math.random() * this.max
        }

        dirCount(){
            var directors = this.no_of_directors;
            this.no_of_directors = parseInt(directors); 
        }
        sharehCount(){
            var shareholders = this.no_of_shareholders;
            this.no_of_shareholders = parseInt(shareholders); 
        }


        async director_list(){
            await Common.get_shareholder_directors(this.token,this.amad)
                .then(response => { 
                    if (typeof response.data !== 'undefined' && response.data.success == 200) {  
                        var directors   =   response.data.directors; 
                        this.directors  =   directors;   
                    }
                }).catch(e => {
                  console.log(e)
            });
        }
        async shareholder_list(){
            await Common.get_shareholder_shareholders(this.local_storage['access-token'])
                .then(response => { 
                    if (typeof response.data !== 'undefined' && response.data.success == 200) {  
                        var shareholders   =   response.data.shareholders; 
                        this.shareholders  =   shareholders;   
                    }
                }).catch(e => {
                  console.log(e)
            });
        }
        


        uploadFile(event){ 
            var path_item       = event.target.name+'_path';
            var item_url        = event.target.name+'_url';
            var pbar            = event.target.name+'_pbar';
            var pbarp           = event.target.name+'_pbar_p'; 
            var pdiv            = event.target.name+'_pdiv';

            this.form[pdiv]     =   1;   
            this.form[pbar]     =   0;   
            this.form[pbarp]    =  '0%';    

            
            var file        =   event.target.files[0];   
            let form_data   =   new FormData();  
            form_data.append('token',this.token);
            form_data.append('amad' ,this.amad);

            if(typeof file !='undefined' && file!=null){
                form_data.append('file',file); 

                Axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
                var url =Common.base_url()+'upload-shareholder-file';    
                Axios.post(
                    url, 
                    form_data, 
                    {
                        headers: {  
                            'Content-Type': 'multipart/form-data'
                        }, 
                        onUploadProgress: progressEvent => {
                            var loaded:number   =   progressEvent.loaded; 
                            var total:number    =   progressEvent.total;
                            var per             =   parseInt((loaded/total *100).toFixed());   
                            this.form[pbar]     =   per; 
                            this.form[pbarp]    =   per+'%';  

                            if(per==100){
                                this.form[pbarp]    =   'Processing';  
                            } 
                        }, 
                    }
                )
                .then(response => { 
                    if(response.data.success==200){  
                        this.form[pbarp]        =   'Upload Success';  
                        this.form[path_item]    =   response.data.file_path;     
                        this.form[item_url]     =   response.data.file_url;    
                    }else{
                        this.form[pdiv] =   0;   
                        this.form[pbar] =   0;
                        this.form[pbarp]=   '0%';
                         
                        this.toast.info(response.data.message);  
                    } 
                })
                .catch(error => {
                    this.form[pdiv] =   0;   
                    this.form[pbar] =   0;
                    this.form[pbarp]=   'Failed to upload';   
                    this.toast.error('Failed to upload');   
                    return false;
                });  

            }else{ 
                this.toast.info('Please select file first');   
            }
        }
        
        /*Common Funtions*/ 
            country_list(){
                Common.get_all_countries(this.token)
                    .then(response => {
                        if (typeof response.data !== 'undefined' && response.data.success == 1) {  
                            var countries   =   response.data.data.countries;
                            this.countries  =   countries;  
                        }
                    }).catch(e => {
                      console.log(e)
                });
            }
            state_list(country_id){
                Common.get_state_list(country_id)
                    .then(response => {

                        if (typeof response.data !== 'undefined' && response.data.success == 200) {  
                            var states   =   response.data.states;
                            this.states  =   states; 
                        }

                    }).catch(e => {
                      console.log(e)
                });
            }

        /*STEP 1 Functions*/
            openDoc(path){ 
                window.open(path,'_blank');
            } 
            submitForm_1(){
                setTimeout(() => this.load_on=1, 100); 
                var form_records  = JSON.parse(JSON.stringify((this.form)));  
                
                let form_data = new FormData();  
                form_data.append('token'    ,this.token) 
                form_data.append('amad'     ,this.amad)  
                var f1 = [     
                    'user_ref_no',
                    'advisor_ref_no',
                    'profile_pic_path',
                    'company_name',
                    'company_website',
                    'company_registration_no', 
                    'investment_currency', 
                    'investment_amount', 
                    'company_state',
                    'company_type',  
                    'incorporation_date',  
                ]; 
                for (var aW = 0; aW < f1.length; aW++) {   
                    if(typeof form_records[f1[aW]]!=='undefined' && form_records[f1[aW]]!='undefined'){
                        form_data.append(f1[aW],form_records[f1[aW]]);    
                    }else{
                        form_data.append(f1[aW],'');    
                    } 
                }  
 

                Axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
                var url =Common.base_url()+'save-shareholder-domestic-corp-onboard1';  

                Axios.post(
                    url, 
                    form_data, 
                    {
                        headers: {  
                            'Content-Type': 'multipart/form-data'
                        }, 
                        onUploadProgress: function( progressEvent:any ) {
                            var loaded:number   =   progressEvent.loaded;
                            var total:number    =   progressEvent.total;
                            var per             =   parseInt((loaded/total *100).toFixed());  
                        }.bind(this)
                    }
                )
                .then(response => { 
                    if(response.data.success==200){
                        this.fresh_step=0;
                        if(this.next_step==2 || this.next_step=='2'){
                            this.set_step(2); 
                        }else{ 
                            this.set_step(1);  
                        }
                        setTimeout(() => this.load_on=0, 500);  
                        this.toast.success(response.data.message);   
                    }else{ 
                        setTimeout(() => this.load_on=0, 500);  
                        this.toast.error(response.data.message);   
                    } 
                })
                .catch(error => {
                    setTimeout(() => this.load_on=0, 500);   
                });   
            }
           
        /*STEP 2 Funtions*/ 
            submitForm_2(){
                this.load_on=1; 
                var form_records  = JSON.parse(JSON.stringify((this.form)));   
                let form_data = new FormData();  
                
                form_data.append('token'    ,this.token) ;
                form_data.append('amad'     ,this.amad)  ;
                var f2 = [   
                    'registered_address',
                    'company_registration_type',
                    'company_ACN',
                    'mal_activity'  
                ]; 
                for (var aW = 0; aW < f2.length; aW++) {   
                    if(typeof form_records[f2[aW]]!=='undefined' && form_records[f2[aW]]!='undefined'){
                        form_data.append(f2[aW],form_records[f2[aW]]);    
                    }else{
                        form_data.append(f2[aW],'');    
                    } 
                }   
                var message = '';
                var error   = 0; 
                if(error!=0){ 
                    this.toast.error(message);
                    setTimeout(() => this.load_on=0, 500); 
                }else{ 

                    Axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
                    var url =Common.base_url()+'save-shareholder-domestic-corp-onboard2';
                    Axios.post(
                        url, 
                        form_data, 
                        {
                            headers: {  
                                'Content-Type': 'multipart/form-data'
                            }, 
                            onUploadProgress: function( progressEvent:any ) {
                                var loaded:number   =   progressEvent.loaded;
                                var total:number    =   progressEvent.total;
                                var per             =    parseInt((loaded/total *100).toFixed());  
                            }.bind(this)
                        }
                    )
                    .then(response => { 
                        if(response.data.success==200){

                            if(this.next_step==3 || this.next_step=='3'){
                                this.set_step(3); 
                            }else{ 
                                this.set_step(2);  
                            }  
                            setTimeout(() => this.load_on=0, 500);  
                            this.toast.success(response.data.message);
                        }else{ 
                            setTimeout(() => this.load_on=0, 500); 
                            this.toast.error(response.data.message); 
                        } 
                    })
                    .catch(error => {
                        this.toast.error('internal error'); 
                        setTimeout(() => this.load_on=0, 500); 
                    });  
                } 
            }
 
        /*STEP 3 Funtions*/  
            submitForm_3(){
                setTimeout(() => this.load_on=1, 100); 
                var form_records    = JSON.parse(JSON.stringify((this.form)));   
                let form_data       = new FormData();   
                form_data.append('token'    ,this.token) ;
                form_data.append('amad'     ,this.amad)  ;
                form_data.append('no_of_directors'          ,form_records['no_of_directors']);
                form_data.append('default_recipient'          ,form_records['default_recipient']);

                 
                var message = '';
                var error   = 0; 
                if(error!=0){
                    this.toast.error(message);  
                    setTimeout(() => this.load_on=0, 500); 
                }else{  
                    Axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
                    var url =Common.base_url()+'save-shareholder-domestic-corp-onboard3';
                    Axios.post(
                        url, 
                        form_data, 
                        {
                            headers: {  
                                'Content-Type': 'multipart/form-data'
                            }, 
                            onUploadProgress: function( progressEvent:any ) {
                                var loaded:number   =   progressEvent.loaded;
                                var total:number    =   progressEvent.total;
                                var per             =    parseInt((loaded/total *100).toFixed());  
                            }.bind(this)
                        }
                    )
                    .then(response => { 
                        if(response.data.success==200){
                            if(this.next_step==4 || this.next_step=='4'){
                                this.set_step(4); 
                                setTimeout(() => this.load_on=0, 500);   
                                this.toast.success(response.data.message);
                            }else{ 
                                this.set_step(3); 
                                setTimeout(() => this.load_on=0, 500);   
                                this.toast.success(response.data.message);
                            }
                        }else{
                            $('.subBtn').removeAttr('disabled'); 
                            setTimeout(() => this.load_on=0, 500);  
                            this.toast.error(response.data.message);
                        } 
                    })
                    .catch(error => { 
                        setTimeout(() => this.load_on=0, 500); 
                        this.toast.error('Internal Error');
                    });  
                }  
            }

        /*STEP 4 Funtions*/  
            submitForm_4(){
                setTimeout(() => this.load_on=1, 100); 
                var form_records    = JSON.parse(JSON.stringify((this.form)));   
                let form_data       = new FormData();   
                form_data.append('token'    ,this.token); 
                form_data.append('amad'     ,this.amad);   
                form_data.append('no_of_shareholders'    ,form_records['no_of_shareholders']); 

                 
                var message = '';
                var error   = 0; 
                if(error!=0){
                    this.toast.error(message);  
                    setTimeout(() => this.load_on=0, 500); 
                }else{  
                    Axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
                    var url =Common.base_url()+'save-shareholder-domestic-corp-onboard4';
                    Axios.post(
                        url, 
                        form_data, 
                        {
                            headers: {  
                                'Content-Type': 'multipart/form-data'
                            }, 
                            onUploadProgress: function( progressEvent:any ) {
                                var loaded:number   =   progressEvent.loaded;
                                var total:number    =   progressEvent.total;
                                var per             =   parseInt((loaded/total *100).toFixed());  
                            }.bind(this)
                        }
                    )
                    .then(response => { 
                        if(response.data.success==200){ 
                            this.set_step(5); 
                            setTimeout(() => this.load_on=0, 500);   
                            this.toast.success(response.data.message);
                         
                        }else{
                            $('.subBtn').removeAttr('disabled'); 
                            setTimeout(() => this.load_on=0, 500);  
                            this.toast.error(response.data.message);
                        } 
                    })
                    .catch(error => { 
                        setTimeout(() => this.load_on=0, 500); 
                        this.toast.error('Internal Error');
                    });  
                }  
            }

        /*STEP 5 Funtions*/  
            submitForm_5(){
                setTimeout(() => this.load_on=1, 100); 
                var form_records    = JSON.parse(JSON.stringify((this.form)));   
                let form_data       = new FormData();   
                form_data.append('token'    ,this.token); 
                form_data.append('amad'     ,this.amad);   
                 
                var message = '';
                var error   = 0; 
                if(error!=0){
                    this.toast.error(message);  
                    setTimeout(() => this.load_on=0, 500); 
                }else{  
                    Axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
                    var url =Common.base_url()+'save-shareholder-domestic-corp-onboard5';
                    Axios.post(
                        url, 
                        form_data, 
                        {
                            headers: {  
                                'Content-Type': 'multipart/form-data'
                            }, 
                            onUploadProgress: function( progressEvent:any ) {
                                var loaded:number   =   progressEvent.loaded;
                                var total:number    =   progressEvent.total;
                                var per             =   parseInt((loaded/total *100).toFixed());  
                            }.bind(this)
                        }
                    )
                    .then(response => { 
                        if(response.data.success==200){ 
                            this.set_step(6); 
                            setTimeout(() => this.load_on=0, 500);   
                            this.toast.success(response.data.message); 
                        }else{
                            $('.subBtn').removeAttr('disabled'); 
                            setTimeout(() => this.load_on=0, 500);  
                            this.toast.error(response.data.message);
                        } 
                    })
                    .catch(error => { 
                        setTimeout(() => this.load_on=0, 500); 
                        this.toast.error('Internal Error');
                    });  
                }  
            }

        /*STEP 6 Funtions*/ 
            submitForm_6(){
                setTimeout(() => this.load_on=1, 100); 
                var form_records  = JSON.parse(JSON.stringify((this.form)));   
                let form_data = new FormData();  
                
                form_data.append('token'    ,this.token) 
                form_data.append('amad'     ,this.amad)  
                form_data.append('esign_name'               ,form_records['esign_name']);
                form_data.append('esign_phone_no'           ,form_records['esign_phone_no']);
                form_data.append('esign_dob'                ,form_records['esign_dob']);
                form_data.append('esign_email_id'           ,form_records['esign_email_id']); 

                var message = '';
                var error   = 0; 
                if(error!=0){
                    this.toast.error(message); 

                    setTimeout(() => this.load_on=0, 500); 
                }else{  
                    Axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
                    var url =Common.base_url()+'save-shareholder-domestic-corp-onboard6';
                    Axios.post(
                        url, 
                        form_data, 
                        {
                            headers: {  
                                'Content-Type': 'multipart/form-data'
                            }, 
                            onUploadProgress: function( progressEvent:any ) {
                                var loaded:number   =   progressEvent.loaded;
                                var total:number    =   progressEvent.total;
                                var per             =    parseInt((loaded/total *100).toFixed());  
                            }.bind(this)
                        }
                    )
                    .then(response => { 
                        if(response.data.success==200){
                            if(this.next_step==7 || this.next_step=='7'){
                                this.set_step(7); 
                                setTimeout(() => this.load_on=0, 500);   
                                this.toast.success(response.data.message);
                            }else{ 
                                this.set_step(6); 
                                setTimeout(() => this.load_on=0, 500);   
                                this.toast.success(response.data.message);
                            }
                        }else{
                            $('.subBtn').removeAttr('disabled'); 
                            setTimeout(() => this.load_on=0, 500);  
                            this.toast.error(response.data.message);
                        } 
                    })
                    .catch(error => { 
                        setTimeout(() => this.load_on=0, 500); 
                        this.toast.error('INternal Error');
                    });  
                } 
            }

        /*STEP 7 Funtions*/ 
            submitForm_7(){
                setTimeout(() => this.load_on=1,100); 
                var form_records  = JSON.parse(JSON.stringify((this.form)));   
                let form_data = new FormData();   

                form_data.append('token'    ,this.token) 
                form_data.append('amad'     ,this.amad)  
                var f1 = [    
                    'aus_stock_doc_path',
                    'asic_extract_path',
                    'org_chart_share_path',
                    'association_article_path'  
                ]; 
                for (var aW = 0; aW < f1.length; aW++) {   
                    if(typeof form_records[f1[aW]]!=='undefined' && form_records[f1[aW]]!='undefined' && form_records[f1[aW]]!='null'){
                        form_data.append(f1[aW],form_records[f1[aW]]);    
                         
                    }else{
                        form_data.append(f1[aW],'');    
                    } 
                }   

                var message = '';
                var error   = 0; 
                if(error!=0){
                    this.toast.error(message); 
                    setTimeout(() => this.load_on=0, 500); 
                }else{  
                    Axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
                    var url =Common.base_url()+'save-shareholder-domestic-corp-onboard7';   
                    Axios.post(
                        url, 
                        form_data, 
                        {
                            headers: {  
                                'Content-Type': 'multipart/form-data'
                            }, 
                            onUploadProgress: progressEvent => {
                                var loaded:number   =   progressEvent.loaded; 
                                var total:number    =   progressEvent.total;
                                var per             =   parseInt((loaded/total *100).toFixed());    
                            }  
                        }
                    )
                    .then(response => { 
                        if(response.data.success==200){
                            if(this.next_step==200 || this.next_step=='200'){   
                                this.complete_corporate_application();

                            }else{   
                                this.set_step(7); 
                                // setTimeout(() => this.load_on=0, 500); 
                                this.toast.success(response.data.message);  
                            }
                            setTimeout(() => this.load_on=0, 500); 
                        }else{ 
                            setTimeout(() => this.load_on=0, 500); 
                            this.toast.error(response.data.message);   
                        } 
                    })
                    .catch(error => { 
                        this.toast.info('Internal Error');  
                        setTimeout(() => this.load_on=0, 500); 
                    });  
                } 
            }



            openModal(id: any) {
                $('#' + id).addClass('d-block');
                $('#' + id).addClass('show');
                $('#' + id).css('overflow-y', 'scroll');
            }
            closeModal(id: any,reload=false) {
                $('#' + id).removeClass('d-block');
                $('#' + id).addClass('d-none');
                $('#' + id).removeClass('show');
                if(reload==true){
                    location.reload();
                }
            }  
            cancel_request(reg_type=2){ 
                this.load_on=1; 
                var form_records    = JSON.parse(JSON.stringify((this.form)));   
                let form_data       = new FormData();   
                form_data.append('token'    ,this.token); 
                form_data.append('amad'     ,this.amad);  
                form_data.append('reg_type'     ,reg_type.toString());                    

                Axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
                var url =Common.base_url()+'shareholder-onboarding-request-cancel';   
                Axios.post(
                    url, 
                    form_data, 
                    {
                        headers: {  
                            'Content-Type': 'multipart/form-data'
                        }, 
                        onUploadProgress: function( progressEvent:any ) {
                            var loaded:number   =   progressEvent.loaded;
                            var total:number    =   progressEvent.total;
                            var per             =    parseInt((loaded/total *100).toFixed());  
                        }.bind(this)
                    }
                )
                .then(response => { 
                    if(response.data.success==200){ 
                        setTimeout(() => this.load_on=0, 500);  
                        this.toast.success(response.data.message);   
                        setTimeout(() => location.href="https://caprock.com.au", 500);
                        
                    }else{ 
                        setTimeout(() => this.load_on=0, 500);  
                        this.toast.error(response.data.message);   
                    } 
                })
                .catch(error => { 
                    setTimeout(() => this.load_on=0, 500); 
                    this.toast.error('Internal Error');   
                });   
            }

            complete_corporate_application(){
                this.load_on=1; 
                var form_records    = JSON.parse(JSON.stringify((this.form)));   
                let form_data       = new FormData();   
                form_data.append('token'    ,this.token) ;
                form_data.append('amad'     ,this.amad) ;  

                Axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
                var url =Common.base_url()+'complete-shareholder-domestic-corp-application';   
                Axios.post(
                    url, 
                    form_data, 
                    {
                        headers: {  
                            'Content-Type': 'multipart/form-data'
                        }, 
                        onUploadProgress: function( progressEvent:any ) {
                            var loaded:number   =   progressEvent.loaded;
                            var total:number    =   progressEvent.total;
                            var per             =    parseInt((loaded/total *100).toFixed());  
                        }.bind(this)
                    }
                )
                .then(response => { 
                    if(response.data.success==200){ 
                        setTimeout(() => this.load_on=0, 500);  
                        this.toast.success(response.data.message);   
                        setTimeout(() => location.href="https://caprock.com.au", 500);  
                    }else{ 
                        setTimeout(() => this.load_on=0, 500);  
                        this.toast.error(response.data.message);   
                    } 
                })
                .catch(error => { 
                    setTimeout(() => this.load_on=0, 500); 
                    this.toast.error('Internal Error');   
                });   
            }






        /*STEP MANAGEMENT*/ 
            async get_active_step(id=0) {

                await Common.get_active_shareholder_onboarding_reg_step(this.token,this.amad)
                    .then(response => {

                        if (typeof response.data !== 'undefined' && response.data.success == 200 && response.data.old_request ==1) {
                            var req=response.data.records;  

                            this.reg_details = req;  
                            if(response.data['company_type']=='' || response.data['company_type']==null){ 
                                this.$router.push('/shareholder-profile?token='+this.token+'&amad='+this.amad); 
                            } 
 
                            if(typeof req['records']!='undefined' && req['records']!=''){
                                this.records  = typeof req['records']!='undefined' &&  req['records']!=null  ? req['records'] : {}; 
   

                                var fArr = [
                                    'profile_pic_url',
                                    'aus_stock_doc_url',
                                    'asic_extract_url',
                                    'org_chart_share_url',
                                    'association_article_url' 
                                ];

                                for (var fA = 0; fA < fArr.length; fA++) {   
                                    if(typeof req[fArr[fA]]!='undefined'){  
                                        this.records[fArr[fA]]         =   req[fArr[fA]];  
                                    }else{
                                        this.records[fArr[fA]]         =   ''; 
                                    } 
                                }    

                            } 
                             
                            var c_steps =  response.data['completed_step'];
                            if(typeof c_steps!='undefined' && c_steps!='' && c_steps!=null){
                                this.completed_steps = c_steps; 
                            }   
                            if(id==1){   
                                this.current_step   =   response.data['current_step'];      
                                if(this.current_step==7){
                                    this.current_step=this.final_step;  
                                }    
                                setTimeout(() => this.set_step(this.current_step), 200);  
                            }  
                            return true;
                        }else{
                            this.current_step   =   1;
                            this.fresh_step     =   1;
                            this.set_step(1);
                            return true;
                        }
                    }).catch(e => {
                        console.log(e)
                        return true;
                });
                
            } 

            async set_step(step_id){  
                var prev_step = (step_id-1);  
                
                if(this.fresh_step==0){
                    await this.get_active_step(); 
                } 
                if(this.completed_steps<prev_step && prev_step!=0){ 
                    this.toast.error('Please complete previous step first.');   
                    setTimeout(() => this.load_on=0, 500);
                }else{
                    this.load_on=1; 
                    if(typeof step_id!='undefined' && step_id==1){  
                        
                        this.current_step   =   1;  
                        this.active_tab     =   'company'; 
 

                        this.form['user_first_name']    =   this.user_info['user_first_name'];
                        this.form['user_last_name']     =   this.user_info['user_last_name'];    
                        this.form['user_ref_no']        =   this.user_info['client_no'];
                        if(typeof this.user_info['user_advisor_user_id']!='undefined' && this.user_info['user_advisor_user_id']!='' && this.user_info['user_advisor_user_id']!=null){
                            this.form['advisor_ref_no']     =  'A0'+this.user_info['user_advisor_user_id'];  
                            this.advisor_exist=1;
                        }
                        
                        if(typeof this.records!='undefined' && this.records!=null && typeof this.records['company']!=='undefined' ){  
                            var company    = this.records['company']; 

                            var st1 = [
                                'user_ref_no',
                                'advisor_ref_no',
                                'profile_pic_path',
                                'company_name',
                                'company_website',
                                'company_registration_no', 
                                'investment_currency', 
                                'investment_amount', 
                                'company_state',
                                'company_type',  
                                'incorporation_date'  
                            ];
                            var string_st1 = [     
                                // 'is_foreign_registered' 
                            ]; 
                            for (var stW1 = 0; stW1 < st1.length; stW1++) {   
                                if(typeof company[st1[stW1]]!=='undefined' && company[st1[stW1]]!='undefined' && company[st1[stW1]]!='null' && company[st1[stW1]]!=null && company[st1[stW1]]!='')
                                {  
                                    this.form[st1[stW1]]         =   company[st1[stW1]];  
                                }else{
                                    this.form[st1[stW1]]         =   ''; 
                                } 
                            }   
                        }   
                        setTimeout(() => this.load_on=0, 500);

                    }else if(typeof step_id!='undefined' && (step_id==2)){  
                        await this.country_list();  
                        this.current_step   =   2;  
                        this.active_tab     =   'business';  

                        if(typeof this.records['business']!=='undefined' ){ 
                            var business    = this.records['business']; 
                            
                            var st2 = [    
                                'registered_address',
                                'company_registration_type',
                                'company_ACN',
                                'mal_activity'  
                            ]; 
                              
                            for (var stW = 0; stW < st2.length; stW++) {   
                                if(typeof business[st2[stW]]!=='undefined' && business[st2[stW]]!='undefined' && business[st2[stW]]!='null' && business[st2[stW]]!=null && business[st2[stW]]!='')
                                {  
                                    this.form[st2[stW]]         =   business[st2[stW]];  
                                }else{
                                    this.form[st2[stW]]         =   ''; 
                                } 
                            }   
                            
                        }    
                        setTimeout(() => this.load_on=0, 500);
     
                        
                    }else if(typeof step_id!='undefined' && step_id==3){    
                         
                        await this.director_list();     
                        this.current_step   =   3;  
                        this.active_tab     =   'director';       


                        if(typeof this.records['director']!=='undefined' ){ 
                            var Mdirector    = this.records['director'];  
                            var st3 = [    
                                'no_of_directors',
                                'default_recipient'  
                            ];  
                            for (var stW3 = 0; stW3 < st3.length; stW3++) {   
                                if(typeof Mdirector[st3[stW3]]!=='undefined' && Mdirector[st3[stW3]]!='undefined' && Mdirector[st3[stW3]]!='null' && Mdirector[st3[stW3]]!=null && Mdirector[st3[stW3]]!='')
                                {  
                                    this.form[st3[stW3]]         =   Mdirector[st3[stW3]];  
                                }else{
                                    this.form[st3[stW3]]         =   ''; 
                                } 
                            }    
                        }   


                        setTimeout(() => this.load_on=0, 500);

                    }else if(typeof step_id!='undefined' && step_id==4){    
                         
                        await this.director_list();     
                        this.current_step   =   4;  
                        this.active_tab     =   'shareholder';       


                        if(typeof this.records['director']!=='undefined' ){ 
                            var Shareholder    = this.records['shareholder'];  
                            var st4 = [    
                                'no_of_shareholders'   
                            ];  
                            for (var stW4 = 0; stW4 < st4.length; stW4++) {   
                                if(typeof Shareholder[st4[stW4]]!=='undefined' && Shareholder[st4[stW4]]!='undefined' && Shareholder[st4[stW4]]!='null' && Shareholder[st4[stW4]]!=null && Shareholder[st4[stW4]]!='')
                                {  
                                    this.form[st4[stW4]]         =   Shareholder[st4[stW4]];  
                                }else{
                                    this.form[st4[stW4]]         =   ''; 
                                } 
                            }    
                        }    
                        setTimeout(() => this.load_on=0, 500);

                    }else if(typeof step_id!='undefined' && step_id==5){    
                        // await this.bank_list();    
                        this.current_step   =   5;  
                        this.active_tab     =   'account';         
                        setTimeout(() => this.load_on=0, 500);

                    }else if(typeof step_id!='undefined' && step_id==6){   
                        this.current_step   =   6;  
                        this.active_tab     =   'e_signature';         
                        var e_signature:any =   this.records['e_signature']; 
                        
                        this.form['esign_email_id']    =   this.shareholder_info['email'];
                        this.form['esign_phone_no']    =   this.shareholder_info['phone_no'];  

                        if(typeof this.records['e_signature']!=='undefined' ){   
                            this.form['esign_dob']          =   e_signature['esign_dob'];
                            this.form['esign_name']         =   e_signature['esign_name'];
                            this.form['esign_email_id']     =   e_signature['esign_email_id'];
                            this.form['esign_phone_no']     =   e_signature['esign_phone_no'];  
                        }     
                        setTimeout(() => this.load_on=0, 500);
                    }else if(typeof step_id!='undefined' && step_id==7){    
                       
                        this.current_step   =   7;  
                        this.active_tab     =   'upload';        
 
                        if(typeof this.records['upload']!=='undefined' ){   
                            var upload:any      =   this.records['upload']; 

                            var f1 = [    
                                'aus_stock_doc_path',
                                'asic_extract_path',
                                'org_chart_share_path',
                                'association_article_path' 
                            ]; 
                            for (var aW = 0; aW < f1.length; aW++) {   
                                if(typeof upload[f1[aW]]!=='undefined' && upload[f1[aW]]!='undefined' && upload[f1[aW]]!='null' && upload[f1[aW]]!=null)
                                {  
                                    this.form[f1[aW]]         =   upload[f1[aW]]; 
                                }else{
                                    this.form[f1[aW]]         =   ''; 
                                } 
                            }   

                        }   
                        setTimeout(() => this.load_on=0, 500);
                    }else{ 
                        this.set_step(1);
                    }
                }
  
                
            }

            
            
            
     
        /*GENERAL */ 
            fetch_file(event:any){  
                var file = event.target.files[0];  
                if(event.target.name=='trans_proof') {
                    this.trans_proof= file; 
                }
                if(event.target.name=='poa_copy') {
                    this.poa_copy= file; 
                } 
            }
             
            get_shareholder_info(token,amad) { 
                Common.get_shareholder_info(token,amad)
                    .then(response => {
                        if (typeof response.data !== 'undefined' && response.data.success == 200) {  
                             // var user_inf=response.data.profile; 

                            if (response.data.s_status==1) {
                                alert('Application completed');
                                location.href="https://caprock.com.au";
                            }

                            // user_inf.join_date=user_inf.join_date?moment(user_inf.join_date).format('DD MMM YYYY '):'';
                            this.shareholder_info=response.data;
                        }else{
                            this.logout();
                        }
                    }).catch(e => {
                      console.log(e)
                });
            }


        /*FORM VALIDATIONS*/  
            validateEmail(value) { 
                const regex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
                if (typeof value!='undefined' && !regex.test(value)) { 
                    return 'This field must be a valid email'; 
                } 
                return true;
            }  
            requiredField(value) { 
                if (!value) {
                    return 'This field is required';
                } 
                return true;
            }
            selectField(value) { 
                if (!value || value=='') {
                    return 'Please select one of option';
                } 
                return true;
            } 
            mobileField(value){ 
                if(typeof value!='undefined'){
                    var phoneNum = value.replace(/[^\d]/g, '');
                    if(phoneNum.length <7 || phoneNum.length > 12) {  
                        return 'This field must be a valid mobile number';
                    }  
                    return true;
                }
                return true; 
            } 

    }
